import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../views/Home';
import Atelier from '../views/Atelier';
import Designer from '../views/Designer';
import Collections from '../views/Collections';
import Contact from '../views/Contact';
import Collection from '../views/Collection';
import News from '../views/News';
import Deconstructed from '../views/Deconstructed';
import PieceOfNews from '../views/PieceOfNews';

const publicPath = '/';

export const routeCodes = {
  HOME_PAGE: publicPath,
  ATELIER: `${ publicPath }atelier`,
  DESIGNER: `${ publicPath }designer`,
  COLLECTIONS: `${ publicPath }collections`,
  COLLECTION: `${ publicPath }collection`,
  CONTACT: `${ publicPath }contact`,
  NEWS: `${ publicPath }news`,
  DECONSTRUCTED: `${ publicPath }deconstructed`,
  PIECEOFNEWS: `${ publicPath }pieceofnews`,
};

export default () => (
  <Switch>
    <Route exact path={ publicPath } component={ Home } />
    <Route path={ routeCodes.ATELIER } component={ Atelier } />
    <Route path={ routeCodes.DESIGNER } component={ Designer } />
    <Route path={ routeCodes.COLLECTIONS } component={ Collections } />
    <Route path={ routeCodes.COLLECTION } component={ Collection } />
    <Route path={ routeCodes.CONTACT } component={ Contact } />
    <Route path={ routeCodes.NEWS } component={ News } />
    <Route path={ routeCodes.DECONSTRUCTED } component={ Deconstructed } />
    <Route path={ routeCodes.PIECEOFNEWS } component={ PieceOfNews } />
  </Switch>
);


// WEBPACK FOOTER //
// ./src/config/routes.js